var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6857CFC1-1611-4A8D-BF49-5652DDBCBA5A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/24x24/help"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "frame",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C7.584,4 4,7.584 4,12 C4,16.416 7.584,20 12,20 C16.416,20 20,16.416 20,12 C20,7.584 16.416,4 12,4 L12,4 Z M12.8,17.6 L11.2,17.6 L11.2,16 L12.8,16 L12.8,17.6 L12.8,17.6 Z M14.456,11.4 L13.736,12.136 C13.16,12.72 12.8,13.2 12.8,14.4 L11.2,14.4 L11.2,14 C11.2,13.12 11.56,12.32 12.136,11.736 L13.128,10.728 C13.424,10.44 13.6,10.04 13.6,9.6 C13.6,8.72 12.88,8 12,8 C11.12,8 10.4,8.72 10.4,9.6 L8.8,9.6 C8.8,7.832 10.232,6.4 12,6.4 C13.768,6.4 15.2,7.832 15.2,9.6 C15.2,10.304 14.912,10.944 14.456,11.4 L14.456,11.4 Z",
    id: "icon",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.8eaba185c5d606b5866ae3c6997240df.svg";
export { ForwardRef as ReactComponent };